import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromNavArea from './nav-area/state/map-safety-nav-area.reducer';
import * as fromSar from './sar/state/map-safety-sar.reducer';
import { MapSafetyNavAreaApi } from './nav-area/api/map-safety-nav-area.api';
import { MapSafetyNavAreaEffects } from './nav-area/state/map-safety-nav-area.effects';
import { MapSafetySarApi } from './sar/api/map-safety-sar.api';
import { MapSafetySarEffects } from './sar/state/map-safety-sar.effects';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(fromNavArea.FEATURE_KEY, fromNavArea.reducer),
        StoreModule.forFeature(fromSar.FEATURE_KEY, fromSar.reducer),
        EffectsModule.forFeature([MapSafetyNavAreaEffects, MapSafetySarEffects]),
    ],
    providers: [MapSafetyNavAreaApi, MapSafetySarApi],
})
export class SafetyDataAccessModule {}
